<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12">
        <h1 class="search">
          {{ $t('Search.title') }}
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Free",
  data: () => ({}),
}
</script>

<style scoped>
.search{
  font-size: 40px;
}
</style>